import { render } from "./AccountModal.vue?vue&type=template&id=21d2dfe7&scoped=true&ts=true"
import script from "./AccountModal.vue?vue&type=script&lang=ts"
export * from "./AccountModal.vue?vue&type=script&lang=ts"

import "./AccountModal.vue?vue&type=style&index=0&id=21d2dfe7&scoped=true&lang=css"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\ATTP_PC03\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d2dfe7"]])

export default __exports__